import { CURRENT_APP_QUERY_PARAMETER } from "@/constants/current_app";
import { globalLoggerToken, gwStorefrontAppInfoToken } from "@/tokens";
import ApiClient from "@lib/ApiClient";
import ApiClientWithMetrics from "@lib/ApiClient/ApiClientWithMetrics";
import AuthApiClient from "@lib/ApiClient/AuthApiClient";
import { AnalyticsEventsCollectorModule } from "@modules/analytics_events_collector/AnalyticsEventsCollectorModule";
import { CommonModule } from "@modules/common_module/CommonModule";
import { TokenManagerModule } from "@modules/token_manager/TokenManagerModule";
import { container, instanceCachingFactory, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import { legacyTrackingApiClient, trackingApiServiceToken } from "./di_tokens";
import { TrackingApiService } from "./services/TrackingApiService";

@singleton()
export class LegacyTrackingModule
    implements
        ModuleInterface<{
            trackingApiService: TrackingApiService;
        }>
{
    exports: { trackingApiService: TrackingApiService };
    public constructor(private readonly commonModule: CommonModule) {
        const legacyTrackingModuleLogger = container
            .resolve(globalLoggerToken)
            .newLogger("LegacyTrackingModule");
        container.register(legacyTrackingApiClient, {
            useFactory: instanceCachingFactory((di) => {
                return new AuthApiClient(
                    new ApiClientWithMetrics(
                        new ApiClient(
                            this.commonModule.exports.baseUrlProvider.appendToBaseUrl(
                                "/storefront-api/v2/"
                            ),
                            undefined,
                            {
                                [CURRENT_APP_QUERY_PARAMETER]: di.resolve(
                                    gwStorefrontAppInfoToken
                                ).currentApp,
                                ...this.commonModule.exports
                                    .designModeQueryParamsProvider.queryParams,
                            },
                            legacyTrackingModuleLogger
                        ),
                        di.resolve(
                            AnalyticsEventsCollectorModule
                        ).exports.eventsCollector,
                        this.commonModule.exports.locationController,
                        di.resolve(
                            AnalyticsEventsCollectorModule
                        ).exports.eventsFactory
                    ),
                    di.resolve(TokenManagerModule).exports.tokenManager
                );
            }),
        });

        const trackingApiService = new TrackingApiService(
            container.resolve(legacyTrackingApiClient),
            legacyTrackingModuleLogger
        );
        container.registerInstance(trackingApiServiceToken, trackingApiService);

        this.exports = {
            trackingApiService,
        };
    }
    public registerProviders() {
        return {};
    }
}
